
(function () {
  if (window.__b2bCasePackQuickShopLoaded) {
    return;
  }

  window.__b2bCasePackQuickShopLoaded = true;

  var quickShopSelector =
    '[data-product-wrapper].product__container--quick-shop';

  function toPositiveInteger(value, fallback) {
    var number = parseInt(value, 10);

    if (Number.isFinite(number) && number > 0) {
      return number;
    }

    return fallback;
  }

  function roundUpToMultiple(quantity, step) {
    if (quantity % step === 0) {
      return quantity;
    }

    return quantity + (step - (quantity % step));
  }

  function parseCasePackMap(productRoot) {
    var mapScript = productRoot.querySelector(
      '[data-b2b-variant-case-pack-map]'
    );

    if (!mapScript) {
      console.warn(
        'Quick Shop case-pack map was not found.'
      );

      return null;
    }

    try {
      return JSON.parse(mapScript.textContent);
    } catch (error) {
      console.warn(
        'Quick Shop case-pack map could not be parsed.',
        error
      );

      return null;
    }
  }

  function getProductFallback(
    productRoot,
    quantityInput
  ) {
    var displayedCasePack = 0;

    productRoot
      .querySelectorAll('.product-text')
      .forEach(function (element) {
        var text = element.textContent || '';

        if (
          text.toLowerCase().indexOf('case pack') === -1
        ) {
          return;
        }

        var valueElement =
          element.querySelector('strong');

        if (valueElement) {
          displayedCasePack =
            toPositiveInteger(
              valueElement.textContent,
              displayedCasePack
            );
        }
      });

    if (displayedCasePack > 0) {
      return displayedCasePack;
    }

    return toPositiveInteger(
      quantityInput.getAttribute(
        'data-increment-value'
      ) ||
        quantityInput.step ||
        quantityInput.min,
      1
    );
  }

  function enhanceQuickShop(productRoot) {
    if (
      !productRoot ||
      productRoot.hasAttribute(
        'data-b2b-case-pack-ready'
      )
    ) {
      return;
    }

    var form = productRoot.querySelector(
      'form[action*="/cart/add"]'
    );

    var quantityInput = productRoot.querySelector(
      '[data-quantity-input], input[name="quantity"]'
    );

    var variantSelection =
      productRoot.querySelector(
        'variant-selection[data-variant-selection]'
      );

    if (
      !form ||
      !quantityInput ||
      !variantSelection
    ) {
      return;
    }

    var casePackMap =
      parseCasePackMap(productRoot);

    if (!casePackMap) {
      return;
    }

    productRoot.setAttribute(
      'data-b2b-case-pack-ready',
      'true'
    );

    var variantInput = form.querySelector(
      '[data-variants][name="id"], [name="id"]'
    );

    var minusButton = productRoot.querySelector(
      '[data-quantity-minus]'
    );

    var plusButton = productRoot.querySelector(
      '[data-quantity-plus]'
    );

    var minusWrapper = productRoot.querySelector(
      '[data-button-wrapper-minus]'
    );

    var productFallbackCasePack =
      getProductFallback(
        productRoot,
        quantityInput
      );

    var currentCasePack =
      productFallbackCasePack;

    var activeVariantId = null;

    function isValidVariantId(variantId) {
      return (
        variantId &&
        variantId !== 'not-selected' &&
        variantId !== 'unavailable'
      );
    }

    function getCurrentVariantId() {
      var attributeVariantId =
        variantSelection.getAttribute('variant');

      if (
        isValidVariantId(attributeVariantId)
      ) {
        return attributeVariantId;
      }

      if (
        variantInput &&
        isValidVariantId(variantInput.value)
      ) {
        return variantInput.value;
      }

      return null;
    }

    function getVariantCasePack(variantId) {
      var mapKey = String(variantId || '');

      if (
        Object.prototype.hasOwnProperty.call(
          casePackMap,
          mapKey
        )
      ) {
        return toPositiveInteger(
          casePackMap[mapKey],
          productFallbackCasePack
        );
      }

      return productFallbackCasePack;
    }

    function updateMinusButton() {
      if (!minusWrapper) {
        return;
      }

      var quantity = toPositiveInteger(
        quantityInput.value,
        currentCasePack
      );

      if (quantity <= currentCasePack) {
        minusWrapper.classList.add(
          'quantity-selector__button-wrapper--disabled'
        );
      } else {
        minusWrapper.classList.remove(
          'quantity-selector__button-wrapper--disabled'
        );
      }
    }

    function updateCasePackDisplay() {
      // Preserve production's "sts" suffix.
      var dedicatedLabels = productRoot.querySelectorAll(
        '[data-b2b-variant-case-pack-display]'
      );

      if (dedicatedLabels.length) {
        dedicatedLabels.forEach(function (element) {
          element.textContent = currentCasePack + ' sts';
        });
        return;
      }

      // Fallback for the original DEV product Text block.
      productRoot
        .querySelectorAll('.product-text')
        .forEach(function (element) {
          var text = element.textContent || '';

          if (
            text.toLowerCase().indexOf('case pack') === -1
          ) {
            return;
          }

          var valueElement =
            element.querySelector('strong');

          if (valueElement) {
            var hasSts = /\bsts\b/i.test(
              valueElement.textContent || ''
            );

            valueElement.textContent =
              String(currentCasePack) +
              (hasSts ? ' sts' : '');
          }
        });
    }

    function dispatchQuantityUpdate() {
      quantityInput.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );
    }

    function setQuantity(quantity) {
      quantity = toPositiveInteger(
        quantity,
        currentCasePack
      );

      quantity = Math.max(
        currentCasePack,
        roundUpToMultiple(
          quantity,
          currentCasePack
        )
      );

      quantityInput.value =
        String(quantity);

      updateMinusButton();
      dispatchQuantityUpdate();
    }

    function applyVariant(variantId) {
      if (!isValidVariantId(variantId)) {
        return;
      }

      variantId = String(variantId);

      var newCasePack =
        getVariantCasePack(variantId);

      if (
        activeVariantId === variantId &&
        currentCasePack === newCasePack
      ) {
        return;
      }

      activeVariantId = variantId;
      currentCasePack = newCasePack;

      productRoot.setAttribute(
        'data-b2b-active-variant',
        variantId
      );

      productRoot.setAttribute(
        'data-b2b-active-case-pack',
        String(currentCasePack)
      );

      quantityInput.min =
        String(currentCasePack);

      quantityInput.step =
        String(currentCasePack);

      quantityInput.setAttribute(
        'data-increment-value',
        String(currentCasePack)
      );

      if (minusButton) {
        minusButton.setAttribute(
          'aria-label',
          'Decrease quantity by ' +
            currentCasePack
        );
      }

      if (plusButton) {
        plusButton.setAttribute(
          'aria-label',
          'Increase quantity by ' +
            currentCasePack
        );
      }

      updateCasePackDisplay();
      setQuantity(currentCasePack);
    }

    /*
     * Empire updates this attribute whenever
     * the selected Quick Shop variant changes.
     */
    var variantObserver =
      new MutationObserver(
        function (mutations) {
          mutations.forEach(
            function (mutation) {
              if (
                mutation.attributeName !==
                'variant'
              ) {
                return;
              }

              applyVariant(
                variantSelection.getAttribute(
                  'variant'
                )
              );
            }
          );
        }
      );

    variantObserver.observe(
      variantSelection,
      {
        attributes: true,
        attributeFilter: ['variant']
      }
    );

    /*
     * Use Empire's variant event as a
     * secondary synchronization method.
     */
    variantSelection.addEventListener(
      'variant-change',
      function (event) {
        var variant =
          event.detail &&
          event.detail.variant
            ? event.detail.variant
            : null;

        if (variant) {
          applyVariant(variant.id);
        }
      }
    );

    /*
     * Fallback for dropdowns, radios,
     * and swatch controls.
     */
    variantSelection.addEventListener(
      'change',
      function () {
        window.setTimeout(
          function () {
            applyVariant(
              getCurrentVariantId()
            );
          },
          0
        );
      }
    );

    productRoot.addEventListener(
      'click',
      function (event) {
        var target = event.target;

        if (
          !target ||
          typeof target.closest !== 'function'
        ) {
          return;
        }

        var clickedMinus = target.closest(
          '[data-quantity-minus]'
        );

        var clickedPlus = target.closest(
          '[data-quantity-plus]'
        );

        if (
          !clickedMinus &&
          !clickedPlus
        ) {
          return;
        }

        if (!productRoot.contains(target)) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        var quantity = toPositiveInteger(
          quantityInput.value,
          currentCasePack
        );

        if (clickedPlus) {
          setQuantity(
            quantity + currentCasePack
          );
        } else {
          setQuantity(
            quantity - currentCasePack
          );
        }
      },
      true
    );

    quantityInput.addEventListener(
      'change',
      function () {
        setQuantity(
          quantityInput.value
        );
      }
    );

    quantityInput.addEventListener(
      'blur',
      function () {
        setQuantity(
          quantityInput.value
        );
      }
    );

    /*
     * Initialize using Empire's
     * currently selected variant.
     */
    applyVariant(
      getCurrentVariantId()
    );
  }

  function inspectNode(node) {
    if (!(node instanceof HTMLElement)) {
      return;
    }

    if (node.matches(quickShopSelector)) {
      enhanceQuickShop(node);
    }

    node
      .querySelectorAll(quickShopSelector)
      .forEach(function (productRoot) {
        enhanceQuickShop(productRoot);
      });
  }

  function start() {
    document
      .querySelectorAll(quickShopSelector)
      .forEach(function (productRoot) {
        enhanceQuickShop(productRoot);
      });

    var quickShopObserver =
      new MutationObserver(
        function (mutations) {
          mutations.forEach(
            function (mutation) {
              mutation.addedNodes.forEach(
                function (node) {
                  inspectNode(node);
                }
              );
            }
          );
        }
      );

    quickShopObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }
})();
